import React, { useState } from 'react'
import { ColorPicker } from 'primereact/colorpicker'

const ColorPickerBasic = () => {
    const [color, setColor] = useState<any>('1976D2')

    return (
        <ColorPicker
            value={color}
            onChange={(e) => setColor(e.value)}></ColorPicker>
    )
}

export default ColorPickerBasic
